import axios from "axios";
import { useEffect, useState } from "react";
// import { CountryData } from "react-phone-input-2";
import { Button, CustomPhoneInput } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";
import Select from "react-select";
// import { useSelector } from "react-redux";
// import { RootState } from "services/redux/store";
import { languageObject } from "assets/data/languages";
// import { languagesArray, languageObject } from "assets/data/languages";

export type SignupForm3Props = CustomComponentProps & {
    phone: string;
    changePhone: Function;
    phoneError: string | undefined;
    validePhone: boolean;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
    openLangModal: React.Dispatch<React.SetStateAction<boolean>>;
    selectedLang: languageObject[];
    toggleLang: Function;
};

export type CountryObject = {
    name: {
        common: string;
        official: string;
    };
    flags: {
        png: string;
        svg: string;
        alt: string;
    };
    cca2: string;
    cca3: string;
};

export type SelectCountryObject = {
    value: string;
    label: string;
    flag: string;
};

const SignupForm3 = ({
    phone,
    changePhone,
    phoneError,
    // validePhone,
    changeStep,
    step,
    openLangModal,
    selectedLang,
    toggleLang
}: SignupForm3Props) => {
    const [selectedCountry, setSelectedCountry] =
        useState<SelectCountryObject | null>();
    const [countries, setCountries] = useState<SelectCountryObject[]>([]);

    // const location = useSelector((state: RootState) => state.site.location);

    const getCountries = async () => {
        try {
            const res = await axios.get(
                "https://restcountries.com/v3.1/all?fields=name,flags,cca2,cca3"
            );
            const destructCountries: SelectCountryObject[] = (
                res.data as CountryObject[]
            ).map((count) => ({
                value: count.cca2,
                label: count.name.common,
                flag: count.flags.svg
            }));
            setCountries(destructCountries);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCountries();
    }, []);

    const handleChangePhone = (
        e: string
        // contactno: string,
        // dialCode: string,
        // val: CountryData
    ) => {
        changePhone(e);
    };

    // fix this later
    // useEffect(() => {
    //     if (
    //         !selectedCountry &&
    //         countries.length &&
    //         // fucj
    //         location
    //     ) {
    //         const country = countries.filter(
    //             (count) => count.value.toLowerCase() == location.toLowerCase()
    //         )[0];
    //         console.log("found", country);
    //         setSelectedCountry(country);
    //     }
    // }, [countries, location]);

    return (
        <div
            id="signup-panel-3"
            className={`process-panel-wrap is-narrow ${step == 2 ? "is-active" : ""}`}
        >
            <div className="form-panel">
                <div className="field">
                    <label>Country</label>
                    <div className="control p-relative country-control">
                        <Select
                            defaultValue={selectedCountry}
                            onChange={setSelectedCountry}
                            options={countries}
                            formatOptionLabel={(country) => (
                                <div className="country-option d-flex gap-5 momeento-p">
                                    <img
                                        src={country.flag}
                                        alt="country-image"
                                    />
                                    <span>{country.label}</span>
                                </div>
                            )}
                            // menuIsOpen={true}
                        />
                    </div>
                </div>

                <CustomPhoneInput
                    value={phone}
                    handleChange={handleChangePhone}
                    error={phoneError}
                />

                <div className="field">
                    <div className="pb-15 d-flex flex-j-between">
                        <label>Languages</label>
                        <div className="tooltip">
                            <div className="momeento-svg info-svg svg-18"></div>
                            <span className="tooltiptext momeento-p">
                                You can select up to four Languages to explore
                                your posts and incidents to all users who speak
                                same language you selected.
                            </span>
                        </div>
                    </div>
                    <div
                        className="d-flex flex-j-start gap-5 flex-wrap"
                        id="displayed-langs-container"
                    >
                        {selectedLang.map((lang) => (
                            <div
                                key={lang.code}
                                className="button is-primary is-rounded raised d-flex flex-j-between flex-a-center gap-10"
                                onClick={() => toggleLang(lang)}
                            >
                                <span className="lang-name">
                                    {lang.nativeName}
                                </span>
                                <span className="remove-lang close-svg momeento-svg"></span>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex flex-j-end">
                        <div className="buttons">
                            {/* <a
                                className="button modal-trigger"
                                data-modal="language-modal"
                            >
                                select languages
                            </a> */}

                            <Button
                                text="select languages"
                                color=""
                                className="modal-trigger"
                                handleClick={() => openLangModal(true)}
                            />
                        </div>
                    </div>
                    <p className="field-error is-hidden">error text</p>
                </div>
            </div>

            <div className="buttons">
                <Button
                    text="Back"
                    handleClick={() => changeStep(step - 1)}
                    color=""
                />
                <Button text="Next" handleClick={() => changeStep(step + 1)} />
            </div>
        </div>
    );
};

export default SignupForm3;
